import { render, staticRenderFns } from "./points-ranking.vue?vue&type=template&id=1d8e7036&scoped=true"
import script from "./points-ranking.vue?vue&type=script&lang=js"
export * from "./points-ranking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e7036",
  null
  
)

export default component.exports